export default class CDataDefinition {
	id?: string | null = null;
	name: string | null = null;
	value: Record<string, string> = {};
	type: DataDefinitionType;
	dateCreated: string | null = null;
	dateUpdated: string | null = null;

	constructor(data: Partial<CDataDefinition>) {
		Object.assign(this, data);
		this.value = data?.value ?? {};
	}
}

export enum DataDefinitionType {
	FinanceChannelsRouteOneDJ = 0,
	RouteOneEContract = 1000,
}
